/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { communityControllerCreateV1 } from '../fn/community/community-controller-create-v-1';
import { CommunityControllerCreateV1$Params } from '../fn/community/community-controller-create-v-1';
import { communityControllerDeleteV1 } from '../fn/community/community-controller-delete-v-1';
import { CommunityControllerDeleteV1$Params } from '../fn/community/community-controller-delete-v-1';
import { communityControllerFindByIdV1 } from '../fn/community/community-controller-find-by-id-v-1';
import { CommunityControllerFindByIdV1$Params } from '../fn/community/community-controller-find-by-id-v-1';
import { communityControllerLikedV1 } from '../fn/community/community-controller-liked-v-1';
import { CommunityControllerLikedV1$Params } from '../fn/community/community-controller-liked-v-1';
import { communityControllerMyV1 } from '../fn/community/community-controller-my-v-1';
import { CommunityControllerMyV1$Params } from '../fn/community/community-controller-my-v-1';
import { communityControllerSearchV1 } from '../fn/community/community-controller-search-v-1';
import { CommunityControllerSearchV1$Params } from '../fn/community/community-controller-search-v-1';
import { communityControllerToggleLikeV1 } from '../fn/community/community-controller-toggle-like-v-1';
import { CommunityControllerToggleLikeV1$Params } from '../fn/community/community-controller-toggle-like-v-1';
import { communityControllerUpdateV1 } from '../fn/community/community-controller-update-v-1';
import { CommunityControllerUpdateV1$Params } from '../fn/community/community-controller-update-v-1';
import { CommunityDto } from '../models/community-dto';
import { CommunitySearchResponseDto } from '../models/community-search-response-dto';

@Injectable({ providedIn: 'root' })
export class CommunityService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `communityControllerSearchV1()` */
  static readonly CommunityControllerSearchV1Path = '/api/v1/community/search';

  /**
   * 커뮤니티 게시글 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerSearchV1$Response(params: CommunityControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CommunitySearchResponseDto>> {
    return communityControllerSearchV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 게시글 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerSearchV1(params: CommunityControllerSearchV1$Params, context?: HttpContext): Observable<CommunitySearchResponseDto> {
    return this.communityControllerSearchV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommunitySearchResponseDto>): CommunitySearchResponseDto => r.body)
    );
  }

  /** Path part for operation `communityControllerMyV1()` */
  static readonly CommunityControllerMyV1Path = '/api/v1/community/my';

  /**
   * 내 커뮤니티 게시글 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerMyV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerMyV1$Response(params?: CommunityControllerMyV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommunityDto>>> {
    return communityControllerMyV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 내 커뮤니티 게시글 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerMyV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerMyV1(params?: CommunityControllerMyV1$Params, context?: HttpContext): Observable<Array<CommunityDto>> {
    return this.communityControllerMyV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CommunityDto>>): Array<CommunityDto> => r.body)
    );
  }

  /** Path part for operation `communityControllerLikedV1()` */
  static readonly CommunityControllerLikedV1Path = '/api/v1/community/liked';

  /**
   * 좋아요한 게시글 조회.
   *
   * 회원이 좋아요한 커뮤니티 게시글을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerLikedV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerLikedV1$Response(params?: CommunityControllerLikedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommunityDto>>> {
    return communityControllerLikedV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 좋아요한 게시글 조회.
   *
   * 회원이 좋아요한 커뮤니티 게시글을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerLikedV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerLikedV1(params?: CommunityControllerLikedV1$Params, context?: HttpContext): Observable<Array<CommunityDto>> {
    return this.communityControllerLikedV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CommunityDto>>): Array<CommunityDto> => r.body)
    );
  }

  /** Path part for operation `communityControllerFindByIdV1()` */
  static readonly CommunityControllerFindByIdV1Path = '/api/v1/community/{id}';

  /**
   * 커뮤니티 게시글 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerFindByIdV1$Response(params: CommunityControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CommunityDto>> {
    return communityControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 게시글 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerFindByIdV1(params: CommunityControllerFindByIdV1$Params, context?: HttpContext): Observable<CommunityDto> {
    return this.communityControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommunityDto>): CommunityDto => r.body)
    );
  }

  /** Path part for operation `communityControllerDeleteV1()` */
  static readonly CommunityControllerDeleteV1Path = '/api/v1/community/{id}';

  /**
   * 커뮤니티 게시글 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerDeleteV1$Response(params: CommunityControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return communityControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 게시글 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerDeleteV1(params: CommunityControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.communityControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `communityControllerUpdateV1()` */
  static readonly CommunityControllerUpdateV1Path = '/api/v1/community/{id}';

  /**
   * 커뮤니티 게시글 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  communityControllerUpdateV1$Response(params: CommunityControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return communityControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 게시글 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  communityControllerUpdateV1(params: CommunityControllerUpdateV1$Params, context?: HttpContext): Observable<boolean> {
    return this.communityControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `communityControllerCreateV1()` */
  static readonly CommunityControllerCreateV1Path = '/api/v1/community';

  /**
   * 커뮤니티 게시글 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  communityControllerCreateV1$Response(params: CommunityControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return communityControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 게시글 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  communityControllerCreateV1(params: CommunityControllerCreateV1$Params, context?: HttpContext): Observable<boolean> {
    return this.communityControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `communityControllerToggleLikeV1()` */
  static readonly CommunityControllerToggleLikeV1Path = '/api/v1/community/{id}/toggle-like';

  /**
   * 커뮤니티 좋아요 여부.
   *
   * 커뮤니티 좋아요 여부를 확인합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerToggleLikeV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerToggleLikeV1$Response(params: CommunityControllerToggleLikeV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return communityControllerToggleLikeV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 커뮤니티 좋아요 여부.
   *
   * 커뮤니티 좋아요 여부를 확인합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerToggleLikeV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerToggleLikeV1(params: CommunityControllerToggleLikeV1$Params, context?: HttpContext): Observable<boolean> {
    return this.communityControllerToggleLikeV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
